import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageBusService } from '@xdig/ng-microkernel/micro-frontend';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PROJECT_NAME } from '../../app.config';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly urlIdentification = `${environment.apiExperience}/customer-identification`;

  constructor(private messageBusService: MessageBusService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: any) {
    const url = `${this.urlIdentification}/backend-time`;

    if (error.url === url) {
      this.messageBusService.emit('shell', 'modal.error', {
        component: '',
        payload: null,
        error: {
          code: error?.error?.code,
          description: error?.error?.description,
          errorType: error?.error?.errorType,
        },
        project: PROJECT_NAME,
      });
    }

    return throwError(error);
  }
}
